import { Injectable } from '@angular/core';
import { CacheKind, ReadCacheEntry, openOfflineDb } from './db';

export const SELECTORS_PREFETCH_KEY = 'selectors:prefetch';

@Injectable({
    providedIn: 'root'
})
export class OfflineCacheService {

    buildKey(url: string): string {
        return `GET:${url}`;
    }

    async get(key: string): Promise<any | undefined> {
        const db = await openOfflineDb();
        const entry = await db.get('read_cache', key);
        return entry?.response;
    }

    async getEntry(key: string): Promise<ReadCacheEntry | undefined> {
        const db = await openOfflineDb();
        return db.get('read_cache', key);
    }

    async put(key: string, url: string, response: any, kind: CacheKind = 'entity'): Promise<void> {
        const db = await openOfflineDb();
        await db.put('read_cache', { key, url, method: 'GET', response, cachedAt: Date.now(), kind });
    }
}
